import axios from 'axios';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL_LOCAL,
  timeout: 30000,
});
api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && !error.config?.url?.includes('/api/admin/login')) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    if (!['/login', '/forgot-password', '/reset-password'].includes(window.location.pathname)) window.location.assign('/login');
  }
  return Promise.reject(error);
});
export default api;
